import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import { useStaticDatabaseContextValue } from "#static-database-context-value";

export type StaticDatabaseContextValue = ReturnType<typeof useStaticDatabaseContextValue>;

export const StaticDatabaseContext = createContext(
  defaultError<StaticDatabaseContextValue>("StaticDatabaseContext"),
);
